import React, { useState, useEffect } from "react";

export const RedirectMessageComponent = ({ step }) => {
  const { inputAttributes } = step;
  const key = `html-item-${Math.floor(Math.random() * 1000000)}`;

  const [html, setHtml] = useState("");

  useEffect(() => {
    let tHtml = inputAttributes.html;
    const timeOut = inputAttributes.timeout || 3000;
    let url = inputAttributes.url || "https://lawnbot.biz";
    const target = inputAttributes.target || "_self";

    if (typeof tHtml === "function") {
      tHtml = tHtml();
    }

    if (typeof url === "function") {
      url = url();
    }

    setHtml(tHtml);

    const timer = setTimeout(() => {
      window.open(url, target);
    }, timeOut);

    // Clean up the timer if the component unmounts
    return () => clearTimeout(timer);
  }, [step]);

  return (
    <p
      key={key}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default RedirectMessageComponent;
